<template>
  <a-modal
    :title="modalTitle"
    width="80%"
    :visible="open"
    :footer="null"
    v-highlight
    @cancel="onClose"
    :bodyStyle="{ height: '580px'}"
  >
    <!-- 数据展示 -->
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ y: 380 }"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <div slot="avatar" slot-scope="text, record">
        <img :src="record.avatar" style="width:100px; cursor: pointer;" preview alt=""/>
      </div>
      <template slot="isDefault" slot-scope="text, record">
        <a-tag v-if="!record.isDefault" color="red">否</a-tag>
        <a-tag v-if="record.isDefault" color="green">是</a-tag>
      </template>
      <template slot="responsibilities" slot-scope="text, record">
        <a-tag v-if="record.responsibilities === 1" color="red">管理员</a-tag>
        <a-tag v-if="record.responsibilities === 2" color="green">DM</a-tag>
        <a-tag v-if="record.responsibilities === 3" color="blue">店长</a-tag>
        <a-tag v-if="record.responsibilities === 4" color="purple">副店长</a-tag>
        <a-tag v-if="record.responsibilities === 5" color="orange">吉祥物</a-tag>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(record)" :disabled="record.responsibilities === 1">
          <a-icon type="setting" />设为管理员
        </a>
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      :show-quick-jumper="false"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => `共 ${total} 条`"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import { adminSetShopManager, pageUserShopRelation } from '@/api/played/userShopRelation'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ShopUser',
  props: {
  },
  components: {
  },
  mixins: [tableMixin],
  data () {
    return {
      modalTitle: undefined,
      loading: false,
      list: [],
      total: 0,
      // 查询参数
      queryParam: {
        shopId: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户头像',
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份',
          dataIndex: 'responsibilities',
          scopedSlots: { customRender: 'responsibilities' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否默认店铺',
          dataIndex: 'isDefault',
          scopedSlots: { customRender: 'isDefault' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '加入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList() {
      this.loading = true
      pageUserShopRelation(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onClose () {
      this.open = false
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handle (row) {
      this.modalTitle = `《${row.shopName}》门店成员`
      this.open = true
      this.queryParam = {
        shopId: row.shopId,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDelete (row) {
      var that = this
      this.$confirm({
        title: `确认设置《${row.nickName}》为《${row.shopName}》管理员吗?`,
        onOk () {
          return adminSetShopManager({ shopId: row.shopId, userId: row.userId })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '设置成功',
                3
              )
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
